export function createFilterSelected({
  filterColors,
  setFilterColors,
  filterPatterns,
  setFilterPatterns,
  filterTypes,
  setFilterTypes,
  filterPrices,
  setFilterPrices,
}) {
  return function filterSelected(filter, filterId, isDelete) {
    if (filter === "colors") {
      if (isDelete) {
        setFilterColors((prev) =>
          prev.includes(filterId) ? prev : [...prev, filterId]
        );
      } else {
        setFilterColors((prev) => prev.filter((id1) => id1 !== filterId));
      }
    } else if (filter === "patterns") {
      if (isDelete) {
        setFilterPatterns((prev) =>
          prev.includes(filterId) ? prev : [...prev, filterId]
        );
      } else {
        setFilterPatterns((prev) => prev.filter((id1) => id1 !== filterId));
      }
    } else if (filter === "types") {
      if (isDelete) {
        setFilterTypes((prev) =>
          prev.includes(filterId) ? prev : [...prev, filterId]
        );
      } else {
        setFilterTypes((prev) => prev.filter((id1) => id1 !== filterId));
      }
    } else if (filter === "prices") {
      if (isDelete) {
        setFilterPrices((prev) =>
          prev.includes(filterId) ? prev : [...prev, filterId]
        );
      } else {
        setFilterPrices((prev) => prev.filter((id1) => id1 !== filterId));
      }
    }
  };
}

export function createAddFailedFileToParent({ setUploadedPDFs, setUploadedImages }) {
  return (fileItem, errorMessage, errorType = "server") => {
    const failedFileObj = {
      id: fileItem.id,
      name: fileItem.name,
      size: fileItem.size,
      type: fileItem.file.type,
      status: "error",
      errorMessage: errorMessage,
      errorType: errorType,
      url: null,
      uploadedAt: new Date(),
    };

    if (fileItem.file.type === "application/pdf") {
      setUploadedPDFs((prev) => [...prev, failedFileObj]);
    } else {
      setUploadedImages((prev) => [...prev, failedFileObj]);
    }
  };
}
